export default __webpack_public_path__ + "static/media/f1.7ccc55de.svg";